var _circle, _ellipse, _circle2, _path, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuppliersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 4,
    r: 2,
    stroke: "white",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 8,
    rx: 3,
    ry: 2,
    stroke: "white",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16,
    r: 2,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2M12 22C6.47715 22 2 17.5228 2 12",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 20,
    rx: 3,
    ry: 2,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliersIcon);
export default __webpack_public_path__ + "static/media/suppliers-icon.2aa0141e24f7f7be12b44a787fb2af99.svg";
export { ForwardRef as ReactComponent };